import {BrandingContact} from '../../shared/models/branding.model';
import {BrandingService} from '../api/branding.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ThemeService} from './theme.service';
import {GlobalErrorService} from './global-error.service';

export type BrandingContactAction = {
  label: string;
  href: string;
};

@Injectable({providedIn: 'root'})
export class BrandingContactService {
  constructor(
    private themeService: ThemeService,
    private globalError: GlobalErrorService,
  ) {
  }

  public loadBrandingContactActions(): Observable<BrandingContactAction[]> {
    return this.themeService.getContact().pipe(
      map(brandingContact => this.mapContactToActions(brandingContact)),
      catchError(error => {
        console.error('Error loading branding contact:', error);
        this.globalError.handleUnexpectedError(error);
        return of([]);
      })
    )
  }

  private mapContactToActions(contact: BrandingContact): BrandingContactAction[] {
    const actions: BrandingContactAction[] = [];

    if (contact.phone) {
      actions.push({
        label: 'Teléfono',
        href: `tel:${contact.phone}`
      })
    }

    if (contact.email) {
      actions.push({
        label: 'Mail',
        href: `mailto:${contact.email}`
      })
    }

    if (contact.whatsapp) {
      actions.push({
        label: 'Whatsapp',
        href: this.buildWhatsappHref(contact.whatsapp)
      });
    }

    if (contact.web) {
      actions.push({
        label: 'Web',
        href: contact.web
      });
    }

    return actions;
  }

  private buildWhatsappHref(value: string): string {
    if (value.startsWith('http://') || value.startsWith('https://')) {
      return value;
    }

    const normalizedPhone = value.replace(/[^\d+]/g, '');
    return `https://wa.me/${normalizedPhone.replace('+', '')}`;
  }
}

export function openAction(action: BrandingContactAction): void {
  window.open(action.href, '_blank');
}
